import * as React from 'react';

import {Field} from 'redux-form';

import {nonNull} from 'shells/form/validation/non-null';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import {PipelineSelectSingle} from './pipeline-select-single';

export function LeadCreatedForm() {
    return (
        <StackLegacy spacing={8}>
            <Body>Which pipeline?</Body>
            <Field name='leadCreated' component={PipelineSelectSingle} validate={[nonNull]} />
        </StackLegacy>
    );
}
